import { Flex } from 'common/components/common-styled';
import { ImageContainer, PartDetail, PartImage } from './PartViewFlyout.elements';
import Typography from 'components/Typography/Typography';
import { useGetProductByIdQuery } from 'api';
import CustomLoader from 'components/CustomLoader';
import React from 'react';
import theme from 'themes';

type Props = {
  description: string;
  stock: number;
  sku: string;
  id: string;
  priceUnit?: string;
  machineId?: string;
  custNum?: string;
  [key: string]: unknown;
};
const PartsPopupCard = ({
  description,
  stock,
  sku,
  id,
  machineId,
  priceUnit,
  custNum,
  siteRef,
}: Props): JSX.Element => {
  const { data: product, isLoading: productIsLoading } = useGetProductByIdQuery({
    id: id,
    machineUuid: machineId,
    priceUnit: priceUnit,
    custNum: custNum,
    siteRef
  });
  const partImage = product?.assets?.[0]?.url;
  return (
    <PartDetail>
      <Flex flexWrap="nowrap" gap=".5rem">
        <ImageContainer>
          {productIsLoading ? (
            <CustomLoader size="2.5rem" />
          ) : (
            <PartImage src={partImage ? partImage : '/assets/placeholder/part.svg'} />
          )}
        </ImageContainer>
        <Typography
          mb={0}
          className="part-info"
          weight="normal"
          color={theme.colors.textLightBlack}
        >
          <Typography gap="0.3rem">
            Product Name:
            <Typography weight="semi-bold" mb={0} className="part-info-text">
              {description}
            </Typography>{' '}
          </Typography>
          <Typography mb={'.3rem'}>
            Part No:{' '}
            <Typography weight="semi-bold" mb={0} className="part-info-text">
              {sku}
            </Typography>{' '}
          </Typography>
          {/* <Typography mb={'.3rem'}>Spare Type: <Typography weight="semi-bold" mb={0} className="part-info-text"></Typography></Typography> */}
          <Typography mb={'.3rem'}>
            Quantity:{' '}
            <Typography weight="semi-bold" mb={0} className="part-info-text">
              {stock}
            </Typography>
          </Typography>
        </Typography>
      </Flex>
    </PartDetail>
  );
};

export default PartsPopupCard;
